import { NylasConnectionStatus, NylasConnectionStatusDto } from './nylas-connection-status.dto';

export type NylasConnectionStatusViewModel = {
  calendar: {
    connected: boolean;
    status: NylasConnectionStatus;
    has_online_meetings_authorization?: boolean;
  };
  email: { connected: boolean; status: NylasConnectionStatus };
};

export const toNylasConnectionStatusViewModel = (dto: NylasConnectionStatusDto): NylasConnectionStatusViewModel => {
  return {
    calendar: {
      connected: dto.calendar.connected,
      status: dto.calendar.status,
      has_online_meetings_authorization: dto.calendar.has_online_meetings_authorization,
    },
    email: { connected: dto.email.connected, status: dto.email.status },
  };
};
